module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-lukas-590022-small-ea765d1967689d3984ae7e9b92595acd.jpg";